import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter } from '@stamhoofd/utility';
import { Address } from '../addresses/Address.js';
import { Recipient, Replacement } from '../endpoints/EmailRequest.js';
import { Gender } from '../members/Gender.js';
import { Parent } from '../members/Parent.js';
export class MemberSummary extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.email = null;
        this.gender = Gender.Other;
        this.phone = null;
        this.birthDay = null;
        this.address = null;
        this.parents = [];
    }
    get name() {
        return this.firstName + ' ' + this.lastName;
    }
    get addresses() {
        const addresses = this.parents.map(p => p.address).filter(a => a !== null);
        if (this.address) {
            addresses.push(this.address);
        }
        // Remove duplicates by toString()
        return addresses.filter((a, i, self) => self.findIndex(b => b.toString() === a.toString()) === i);
    }
    get age() {
        if (!this.birthDay) {
            return null;
        }
        // For now calculate based on Brussels timezone (we'll need to correct this later)
        const today = new Date();
        const birthDay = Formatter.luxon(this.birthDay);
        let age = today.getFullYear() - birthDay.year;
        const m = today.getMonth() - (birthDay.month - 1);
        if (m < 0 || (m === 0 && today.getDate() < birthDay.day)) {
            age--;
        }
        return age;
    }
    get emailRecipients() {
        // for each parent
        const recipients = [];
        for (const parent of this.parents) {
            if (parent.email) {
                recipients.push(Recipient.create({
                    firstName: parent.firstName,
                    lastName: parent.lastName,
                    email: parent.email,
                    types: ['parent'],
                    replacements: [
                        Replacement.create({
                            token: 'organization',
                            value: this.organizationName,
                        }),
                    ],
                }));
            }
        }
        if (this.email && (!this.age || this.age >= 18)) {
            recipients.push(Recipient.create({
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                types: ['member'],
                replacements: [
                    Replacement.create({
                        token: 'organization',
                        value: this.organizationName,
                    }),
                ],
            }));
        }
        return recipients;
    }
    get emailaddresses() {
        const emails = this.parents.map(p => p.email).filter(e => e !== null);
        if (this.email && (!this.age || this.age >= 18)) {
            emails.push(this.email);
        }
        // Remove duplicates
        return emails.filter((a, i, self) => self.indexOf(a) === i);
    }
}
__decorate([
    field({ decoder: StringDecoder })
], MemberSummary.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberSummary.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberSummary.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberSummary.prototype, "email", void 0);
__decorate([
    field({ decoder: new EnumDecoder(Gender) })
], MemberSummary.prototype, "gender", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberSummary.prototype, "phone", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], MemberSummary.prototype, "birthDay", void 0);
__decorate([
    field({ decoder: Address, nullable: true })
], MemberSummary.prototype, "address", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Parent) })
], MemberSummary.prototype, "parents", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberSummary.prototype, "organizationName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberSummary.prototype, "organizationId", void 0);
//# sourceMappingURL=MemberSummary.js.map